<div *ngIf="parentContentItems.length" class="form-divider-title headline-small">{{ 'CONTENT.Module_Name' | translate }}: {{ 'SHARED.Inherited' | translate }}</div>
<div class="parent-list">
  <ion-item (click)="openDetailPage(contentItem)" *ngFor="let contentItem of parentContentItems | orderBy: currentOrderByObject.parentOrder"
            lines="full">
    <ng-template [ngTemplateOutlet]="contentTypeRef" [ngTemplateOutletContext]="{ item: contentItem }"></ng-template>
    <ng-template [ngTemplateOutlet]="contentNameRef" [ngTemplateOutletContext]="{ item: contentItem }"></ng-template>
  </ion-item>
</div>

<div class="form-divider-title headline-small">{{ 'CONTENT.Module_Name' | translate }}: {{ 'SHARED.Attached' | translate }}</div>

<div *ngIf="prompt && !contentItems.length" class='text-center'>{{ prompt }}</div>

<app-reorder-list (onChecked)="toggleSelection()" (onClick)="openDetailPage($any($event))" (onReorder)="doReorder()" [config]="reorderConfig"></app-reorder-list>

<div class="add-block">
  <app-folder-picker (onChanged)="onSelectedContent($event)"
                     [selectedIds]="pickerContentItems"
                     [folderPickerInput]="folderPickerInput"></app-folder-picker>
</div>

<ion-footer *ngIf="panelConfig.count" no-border>
  <app-removal-panel (onRemove)="onRemove()" [removeButtonTitle]="panelConfig.removeTitle" [subTitle]="panelConfig.subTitle"
                     [title]="panelConfig.title"></app-removal-panel>
</ion-footer>


<ng-template let-content="item" #contentTypeRef>
  <img *ngIf="content.iconName; else iconClassRef" [src]="content.iconName">
  <ng-template #iconClassRef>
    <div [ngClass]="content.iconClass"></div>
  </ng-template>
</ng-template>

<ng-template let-content="item" #contentNameRef>
  <div class="name">{{ (content | translateBy: 'description') || (content | translateBy: 'title') || ('Unknown (' + (content.objectID || content.folderID) + ')') }}</div>
</ng-template>

<ng-template let-content="item" #contentRemoveRef>
  <ion-button (click)="removeBy(content)" class="page-button" color="secondary" slot="end">{{ "SHARED.Remove" | translate }}</ion-button>
</ng-template>
